import Modal from '@/components/modal/Modal';
import {
  TAgentService,
  useDeleteAgentService,
  useUpdateAgentService,
} from '@/models/agents';
import { memo } from 'react';
import AgentServiceEditor from './AgentServiceEditor';
import { notifications } from '@mantine/notifications';

interface AgentServiceModalProps {
  service: TAgentService;
  opened: boolean;
  onClose: () => void;
  agentId: number;
}

function AgentServiceModal({
  service,
  opened,
  onClose,
  agentId,
}: AgentServiceModalProps) {
  const { mutate: updateService } = useUpdateAgentService();
  const { mutate: deleteService } = useDeleteAgentService(agentId);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Edit service ${service.name}`}
      styles={{ body: { padding: 'sm' } }}
    >
      <AgentServiceEditor
        service={service}
        onSubmit={(service) => {
          updateService(service, {
            onSuccess: () => {
              notifications.show({
                title: 'Service updated',
                message: `Service "${service.name} updated successfully`,
                color: 'green',
                position: 'top-right',
              });
              onClose();
            },
          });
        }}
        onDelete={() => {
          deleteService(service.id, {
            onSuccess: () => {
              notifications.show({
                title: 'Service deleted',
                message: `Service "${service.name}" was deleted successfully.`,
                color: 'green',
                position: 'top-right',
              });
              onClose();
            },
          });
        }}
      />
    </Modal>
  );
}

export default memo(AgentServiceModal);
